import { useMutation } from '@apollo/client';
import { RESPOND_TO_COACH_REQUEST } from '../../apollo/mutations/coachRequest';

const useRespondToCoachRequest = () => {
  const [respondToCoachRequest, { loading, error }] = useMutation(RESPOND_TO_COACH_REQUEST);

  const respond = async (requestId, accept) => {
    await respondToCoachRequest({ variables: { requestId, accept } });
  };

  return { respond, loading, error };
};

export default useRespondToCoachRequest;